import axios from 'axios';
import moment from 'moment';
import { LANGUAGE_CODES, APP_IDS } from '@/support/constants';
import { notifyError } from '../support/utils';

const instance = axios.create();

const LeadApiService = {
  loginRequest(data) {
    return instance.post('https://broker360-identity-api.azurewebsites.net/connect/token', data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).catch((error) => {
      notifyError(error.message);
    });
  },
  sendMail(data, token) {
    return instance.post('https://broker360-sender-api.azurewebsites.net/api/postalmessage', data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).catch((error) => {
      notifyError(error.message);
    });
  },
  sendCRMRecord(data, token) {
    return instance.post('https://broker360-sender-api.azurewebsites.net/api/gateway', data, {
      headers: {
        Authorization: `Bearer ${token}`,
        X_API_REQUEST_URL: 'https://broker360-crm-lead-api.azurewebsites.net/leads/insurance/health',
        X_PARTNER_KEY: window.clientKey,
        X_CALCULATOR_KEY: '0daa47e5-1858-4552-a8bc-f64af3d18222',
      },
    }).catch((error) => {
      notifyError(error.message);
    });
  },
  convertGender(gender) {
    let contactGender = '-';
    if (gender === 'M') {
      contactGender = 'Herr';
    } else if (gender === 'F') {
      contactGender = 'Frau';
    }
    return contactGender;
  },
  convertLeadData(data) {
    const mailData = {
      Request: {
        Customer: {
          Firstname: data.firstName,
          Middlename: null,
          Lastname: data.lastName,
          GenderTypeCode: data.gender,
          Birthdate: moment(data.birthDate).format('YYYY-MM-DD'),
          Email: data.email,
          PhoneNumber: data.phone,
          PrimaryLanguageCode: LANGUAGE_CODES[window.language],
        },
        Address: {
          Street: data.street,
          // Number: data.postCode,
          RegionIntegrationCode: data.region.integrationId,
        },
        Insurance: {
          CurrentBasicIntegrationCode: data.currentInsuranceCompany.groupId,
          Franchise: data.franchise,
          Premium: data.premium ? data.premium : data.cheapestOffer,
          DoctorTypeCode: '914650000',
          PersonInHouse: data.personsHousehold,
        },
        ReferrerUrl: window.location.origin,
        SourceId: APP_IDS.sourceId,
      },
    };
    return mailData;
  },
  convertLeadDataTemplate2(data) {
    const mailData = {
      Request: {
        ContactFormSection: {
          Gender: this.convertGender(data.contactInfos.gender),
          FirstName: data.contactInfos.firstName,
          LastName: data.contactInfos.lastName,
          BirthDate: moment(data.contactInfos.birthDate).format('YYYY-MM-DD'),
          Email: data.contactInfos.email,
          PhoneNumber: data.contactInfos.phone,
          Street: data.contactInfos.street,
          BuildingNumber: data.contactInfos.number,
          PostCode: data.contactInfos.postCode,
          Zone: data.contactInfos.region,
          Language: window.language,
        },
        PersonsSection: [{
          InsuranceStartDate: data.contactInfos.insuranceStartDate,
          InsuranceContractDuration: data.contactInfos.insuranceContractDuration,
          PetName: data.contactInfos.petName,
          PetRace: data.contactInfos.race,
          SelectedInsuranceCompany: data.insuranceInfos.insuranceCompanyName,
          PricePerMonth: data.insuranceInfos.pricePerMonth,
          PricePerYear: data.insuranceInfos.pricePerYear,
          HereditaryDiseases: data.insuranceInfos.hereditaryDiseases,
          Deductible: data.insuranceInfos.deductible,
          InsuredSum: data.insuranceInfos.insuredSum,
        }],
      },
    };
    return mailData;
  },
};

export default LeadApiService;
